import type { ReactNode } from 'react';

interface CardProps {
  title?: ReactNode;
  /** Frase corta que explica al usuario que esta viendo. */
  hint?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  /** Quita el padding interior, util cuando el hijo es una tabla. */
  flush?: boolean;
}

export function Card({
  title,
  hint,
  actions,
  children,
  className = '',
  flush = false,
}: CardProps): JSX.Element {
  return (
    <section className={`card ${className}`.trim()}>
      {(title || actions) && (
        <header className="card__head">
          <div>
            {title && <h2 className="card__title">{title}</h2>}
            {hint && <p className="card__hint">{hint}</p>}
          </div>
          {actions && <div className="card__actions">{actions}</div>}
        </header>
      )}
      <div className={flush ? 'card__body card__body--flush' : 'card__body'}>{children}</div>
    </section>
  );
}
